<script setup lang="ts">
  import type { JourneyItem } from '~/models/journey';
  import { computed } from 'vue';
  import type { PropType } from 'vue';

  const props = defineProps({
    journey: {
      type: Object as PropType<JourneyItem>,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    numItems: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    stepText: {
      type: String,
      required: true
    }
  });

  const indexText = computed(() => `${props.index + 1}`.padStart(2, '0'));
  const numText = computed(() => `${props.numItems}`.padStart(2, '0'));
</script>

<template>
  <div
    :class="[
      'journey-card',
      {
        'journey-card--active': active
      }
    ]">
    <div class="journey-card__indicator" />
    <div class="journey-card__bg">
      <div class="journey-card__ellipse-bg" />
      <div
        class="journey-card__image"
        :style="{ '--journey-image': `url(${journey.img.src})` }" />
      <div class="journey-card__content">
        <h2>{{ journey.title }}</h2>
        <p>{{ journey.description }}</p>
      </div>
      <div class="journey-card__footer">
        <div class="journey-card__step">
          <span>{{ indexText }}. {{ stepText }}</span>
          <span>|</span>
          <span>{{ numText }}</span>
        </div>
        <div class="journey-card__progress" />
      </div>
    </div>
  </div>
</template>
